module.exports = __webpack_public_path__ + "c81cee767f86cb77f1cbb88897e45d84.jpg";